<template lang="html">
  <form action="">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">Login</p>
        <small> <router-link @click.native="close" :to="{ path: '/register' }">No account yet?</router-link> </small>
      </header>
      <ValidationObserver ref="observer" v-slot="{ passes }">
        <section class="modal-card-body">

          <b-notification @close="loginErrors = null" :active="loginErrors != null" type="is-danger" has-icon aria-close-label="Close notification" role="alert">
            {{ loginErrors }}
          </b-notification>

          <ValidationProvider rules="required" name="Login" v-slot="{ errors, valid }">
            <b-field label="Username or email address" :type="{ 'is-danger': errors[0] }" :message="errors">
              <b-input
                type="text"
                v-model="session.login"
                placeholder="Your email or username"
                required>
              </b-input>
            </b-field>
          </ValidationProvider>

          <ValidationProvider rules="required" name="Password" v-slot="{ errors, valid }">
            <b-field label="Password" :type="{ 'is-danger': errors[0] }" :message="errors">
              <b-input
                type="password"
                v-model="session.password"
                password-reveal
                placeholder="Your password"
                required>
              </b-input>
            </b-field>
          </ValidationProvider>

          <small> <router-link @click.native="close" :to="{ path: '/recover' }">Forgot your password?</router-link> </small>
        </section>
        <footer class="modal-card-foot">
          <b-button class="button" type="button" @click="$parent.close()">Close</b-button>
          <b-button type="is-primary" tag="input" native-type="submit" @click.prevent="passes(login)" @keyup.enter="passes(login)" value=Login />
        </footer>

      </ValidationObserver>
    </div>
  </form>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
export default {
  props: ['session'],
  data () {
    return {
      loginErrors: null
    }
  },
  components: {
    ValidationObserver,
    ValidationProvider
  },
  methods: {
    login () {
      this.$store.dispatch('sessions/create', this.session)
        .then(cosplayer => {
          this.close()
          this.$router.push('/').catch(_ => {})
          this.$buefy.toast.open({
            message: `Welcome back, ${cosplayer} ヽ(*⌒▽⌒*)ﾉ !`,
            type: 'is-success'
          })
        })
        .catch(error => {
          this.loginErrors = this.$t(`login.${error.response.data.errors}`)
        })
    },
    close () {
      this.$parent.close()
    }
  }
}
</script>
